import { render } from "./SevenStar.vue?vue&type=template&id=9ef1b6ce&scoped=true"
import script from "./SevenStar.vue?vue&type=script&lang=js"
export * from "./SevenStar.vue?vue&type=script&lang=js"

import "./SevenStar.vue?vue&type=style&index=0&id=9ef1b6ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef1b6ce"]])

export default __exports__